import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

// Подпись группы. В свёрнутом меню вместо неё черта-разделитель, текст остаётся для
// экранного диктора (группа ссылается на подпись через `aria-labelledby`).
export const SidebarGroupLabel = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    data-slot="sidebar-group-label"
    className={cn(
      "px-2.5 pb-1.5 text-xs font-semibold tracking-[0.08em] text-subtle uppercase group-data-[state=collapsed]/sidebar:mb-2 group-data-[state=collapsed]/sidebar:h-px group-data-[state=collapsed]/sidebar:w-9 group-data-[state=collapsed]/sidebar:overflow-hidden group-data-[state=collapsed]/sidebar:bg-border group-data-[state=collapsed]/sidebar:p-0 group-data-[state=collapsed]/sidebar:text-transparent",
      className,
    )}
    {...props}
  />
);
